var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "U the STAR",
      "tabActive": "재단소개",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('dept3-tab', {
    attrs: {
      "page": "재단소개",
      "tabActive": "1"
    }
  }), _c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v("사업 운영 방향")])]), _c('v-row', [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('num-item', {
    attrs: {
      "num": "01"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-bold color-point mb-6 mb-lg-14"
  }, [_vm._v(" 아동 청소년 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 적극 지원 및 후원 ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 아동·청소년 특히 취약계층을 대상으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 스포츠와 VR 체험·학습을 운영하며 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 건강한 성장과 사회 적응을 지원합니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전문가와 지역사회가 함께하는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 교육·나눔 활동으로 지속 가능한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 스포츠 복지 모델을 실현합니다. ")])])], 1), _c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('num-item', {
    attrs: {
      "num": "02"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-bold color-point mb-6 mb-lg-14"
  }, [_vm._v(" 전문 체육인 재취업 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 양성 도모 ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 다양한 종목의 은퇴 선수 출신 전문 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 스포츠 지도자를 배양하여 각종 스포츠 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 봉사활동 및 스포츠 지도자로서 새로운 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 도전을 할 수 있도록 적극 지원 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 후원한다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('num-item', {
    attrs: {
      "num": "03"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-bold color-point mb-6 mb-lg-14"
  }, [_vm._v(" 국내외 스포츠 생활화 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 생활 스포츠 문화 주도 ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 다양한 그룹, 종목별 체육 활동을 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 공정한 참여의 기회를 마련하고, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 국내외 다양한 스포츠 교류를 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 스포츠 대중화 및 K-스포츠 문화의 위상을 높인다. ")])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section bg-image",
    staticStyle: {
      "background-image": "url(/images/sub/about/business/s2-bg.jpg)"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold color-white"
  }, [_vm._v("사업 내용")])]), _vm._l(_vm.items, function (item, index) {
    return _c('business-item', {
      key: index,
      class: {
        'mt-24': index !== 0
      },
      attrs: {
        "num": (index + 1).toString().padStart(2, '0'),
        "tit": item.title
      }
    }, _vm._l(item.items, function (item, index) {
      return _c('p', {
        key: index,
        staticClass: "page-text dot-text",
        class: {
          'mt-2 mt-lg-8': index !== 0
        }
      }, [_vm._v("· " + _vm._s(item))]);
    }), 0);
  })], 2)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v("연혁")])]), _c('sub-history')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }